import { useAppContext } from '../AppContext';
import { useHref, useLocation } from '../router/router';
import { getAbsoluteUrl } from '../util';
import { getLanguageTag } from './util';

/*
  URL canonico della pagina corrente, con la stessa base del canonical emesso da MainHelmet
  (useHref sul solo pathname), ma senza slash finale.
*/
export const useCanonicalUrl = () => {
  const { pathname } = useLocation();
  const href = useHref(pathname);
  return getAbsoluteUrl(href).replace(/\/+$/, '');
};

// Lingua della pagina corrente come tag BCP 47, ricavata da locale e paese di spedizione (vedi getLanguageTag).
export const useLanguageTag = (): string | undefined => {
  const { locale, shippingCountry } = useAppContext();
  return getLanguageTag(locale, shippingCountry);
};
